<template>
    <a-modal title="用户身体数据"
             :width="1200"
             :visible="visible"
             @cancel="close"
             @ok="close">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入用户手机号" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="身高(厘米)" prop="height">-->
<!--                <a-input v-model="queryParam.height" placeholder="请输入身高(厘米)" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
<!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['joe:body:add']">-->
<!--          <a-icon type="plus" />新增-->
<!--        </a-button>-->
<!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['joe:body:edit']">-->
<!--          <a-icon type="edit" />修改-->
<!--        </a-button>-->
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['joe:body:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['joe:body:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :scroll="{ x: 5000 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="lastTime" slot-scope="text, record">
          {{ parseTime(record.lastTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="skinColour" slot-scope="text, record">
            <el-color-picker disabled v-model="record.skinColour" ></el-color-picker>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['joe:body:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['joe:body:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['joe:body:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['joe:body:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-modal>
</template>

<script>
import { pageBody,listBody, delBody } from '@/api/joe/body'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'userBody',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      visible: false,
      userId: null,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        height: null,
        nickname: null,
        mobile: null,
        heightUnit: null,
        weight: null,
        weightUnit: null,
        temperature: null,
        temperatureUnit: null,
        distance: null,
        shrinkPressure: null,
        lowOxygen: null,
        diastolePressure: null,
        distanceUnit: null,
        sex: null,
        birthday: null,
        skinColour: null,
        lastTime: null,
        lastCycle: null,
        lastDays: null,
        heartPolic: null,
        isHeartPolic: null,
        isPriveBloodSugar: null,
        morningBloodSugarBefore: null,
        morningBloodSugarAfter: null,
        noonBloodSugarBefore: null,
        noonBloodSugarAfter: null,
        nightBloodSugarBefore: null,
        nightBloodSugarAfter: null,
        isPrivateBloodComponents: null,
        bloodUricAcid: null,
        bloodCholesterol: null,
        bloodTriglyceride: null,
        bloodHighLipoprotein: null,
        bloodLowLipoprotein: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '${comment}',
        //   dataIndex: 'id',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '用户手机号',
          dataIndex: 'mobile',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '身高(厘米)',
          dataIndex: 'height',
          //ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '身高单位id(外键sys_config.id)',
        //   dataIndex: 'heightUnit',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '体重(kg)',
          dataIndex: 'weight',
          //ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '体重单位id(外键sys_config.id)',
        //   dataIndex: 'weightUnit',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '温度(摄氏度)',
          dataIndex: 'temperature',
          //ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '温度单位id(外键sys_config.id)',
        //   dataIndex: 'temperatureUnit',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '距离',
        //   dataIndex: 'distance',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '血压私人模式-收缩压',
          dataIndex: 'shrinkPressure',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '是否开启低氧唤醒',
          dataIndex: 'lowOxygen',
          //ellipsis: true,
          customRender: function (t) {
            if(t == 0) {
              return '否'
            } else {
              return '是'
            }
          },
          align: 'center'
        },
        {
          title: '血压私人模式-舒张压',
          dataIndex: 'diastolePressure',
          //ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '距离单位id(外键sys_config.id)',
        //   dataIndex: 'distanceUnit',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '性别',
          dataIndex: 'sex',
          //ellipsis: true,
          align: 'center',
          customRender: function (t) {
            if(t == 0) {
              return '保密'
            } else if(t == 1) {
              return '男'
            } else {
              return '女'
            }
          },
        },
        {
          title: '生日',
          dataIndex: 'birthday',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '肤色(色号码)',
          dataIndex: 'skinColour',
          //ellipsis: true,
          scopedSlots: { customRender: 'skinColour' },
          align: 'center'
        },
        {
          title: '女性上次来月经时间',
          dataIndex: 'lastTime',
          scopedSlots: { customRender: 'lastTime' },
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '女性上次来月经周期天数',
          dataIndex: 'lastCycle',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '女性上次来月经天数',
          dataIndex: 'lastDays',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '心率报警值',
          dataIndex: 'heartPolic',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '是否开启心率报警',
          dataIndex: 'isHeartPolic',
          //ellipsis: true,
          customRender: function (t) {
            if(t == 0) {
              return '否'
            } else {
              return '是'
            }
          },
          align: 'center'
        },
        {
          title: '是否开启血糖私人模式',
          dataIndex: 'isPriveBloodSugar',
          //ellipsis: true,
          customRender: function (t) {
            if(t == 0) {
              return '否'
            } else {
              return '是'
            }
          },
          align: 'center'
        },
        {
          title: '血糖私人模式早餐前标准值(毫摩尔/升)',
          dataIndex: 'morningBloodSugarBefore',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血糖私人模式早餐后标准值(毫摩尔/升)',
          dataIndex: 'morningBloodSugarAfter',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血糖私人模式午餐前标准值(毫摩尔/升)',
          dataIndex: 'noonBloodSugarBefore',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血糖私人模式午餐后标准值(毫摩尔/升)',
          dataIndex: 'noonBloodSugarAfter',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血糖私人模式晚餐前标准值(毫摩尔/升)',
          dataIndex: 'nightBloodSugarBefore',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血糖私人模式晚餐后标准值(毫摩尔/升)',
          dataIndex: 'nightBloodSugarAfter',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '是否开启血液成分检测私人模式',
          dataIndex: 'isPrivateBloodComponents',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血液成分检测私人模式尿酸值(微摩尔/升)',
          dataIndex: 'bloodUricAcid',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血液成分检测私人模式总胆固醇值(微摩尔/升)',
          dataIndex: 'bloodCholesterol',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血液成分检测私人模式甘油三酯值(微摩尔/升)',
          dataIndex: 'bloodTriglyceride',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血液成分检测私人模式高密度脂蛋白(微摩尔/升)',
          dataIndex: 'bloodHighLipoprotein',
          //ellipsis: true,
          align: 'center'
        },
        {
          title: '血液成分检测私人模式低密度脂蛋白(微摩尔/升)',
          dataIndex: 'bloodLowLipoprotein',
          //ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   //ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   //ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getUserBody(record) {
      this.userId = record
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
      this.$emit('close')
    },
    /** 查询用户身体设置列表 */
    getList () {
      this.loading = true
      this.queryParam.userId = this.userId
     pageBody(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        height: undefined,
        heightUnit: undefined,
        weight: undefined,
        weightUnit: undefined,
        temperature: undefined,
        temperatureUnit: undefined,
        distance: undefined,
        shrinkPressure: undefined,
        lowOxygen: undefined,
        diastolePressure: undefined,
        distanceUnit: undefined,
        sex: undefined,
        birthday: undefined,
        skinColour: undefined,
        lastTime: undefined,
        lastCycle: undefined,
        lastDays: undefined,
        heartPolic: undefined,
        isHeartPolic: undefined,
        isPriveBloodSugar: undefined,
        morningBloodSugarBefore: undefined,
        morningBloodSugarAfter: undefined,
        noonBloodSugarBefore: undefined,
        noonBloodSugarAfter: undefined,
        nightBloodSugarBefore: undefined,
        nightBloodSugarAfter: undefined,
        isPrivateBloodComponents: undefined,
        bloodUricAcid: undefined,
        bloodCholesterol: undefined,
        bloodTriglyceride: undefined,
        bloodHighLipoprotein: undefined,
        bloodLowLipoprotein: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBody(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('joe/user-body/export', {
            ...that.queryParam
          }, `用户身体设置_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
<style scoped>
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.pagination-container {
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
}

.ant-table-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.ant-pagination {
  display: inline-block;
  margin: 0 auto;
}
</style>